import { Component, Input, OnInit } from '@angular/core'
import { imageStatusUrl } from '@helpers/common'
import { RequestServices } from '@app/services'
import { HttpClient } from '@angular/common/http'
import { AuthService } from '../../services/auth.services'
import { SharedServices } from './../../services/shared.services'
import { CookieService } from 'ngx-cookie-service'
import { Router } from '@angular/router'

declare var cordova: any
declare var window: any

@Component({
    selector: 'app-base-pdf',
    templateUrl: './base-pdf.component.html',
    styleUrls: ['./base-pdf.component.css'],
})
export class BasePdfComponent implements OnInit {
    @Input() pdfId: string
    @Input() name: string = 'File'
    @Input() trimLength: number = 50

    constructor(private http: HttpClient, private requestService: RequestServices, private authData: AuthService, private sharedService: SharedServices, private router: Router, private cookieService: CookieService,) {
    }

    ngOnInit() {
    }

    compactString(str: string) {
        if (str) {
            const max = 50
            str = str.replace('.pdf', '')
            return str.length > max
                ? str.substring(0, max) + '... .pdf'
                : str + '.pdf'
        }
    }

    onClickHandler(event, id, name) {
        event.stopPropagation()
        if (typeof cordova !== 'undefined' && (window.navigator.userAgent.match(/iOS|iPhone|iPad/) || window.navigator.userAgent.match(/Cordova/))) {
            this.onShowPdf({
                id, name,
            })
        } else {
            if (this.authData.getItem('user')) {
                const user = JSON.parse(this.authData.getItem('user'));
                const expires = parseInt((user.expiresInSeconds)) * 1000;
                const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
                const timeNow = Date.now();
                if (timeOut <= timeNow) {
                    this.sharedService.emitChange('closeModalPdf');
                    localStorage.removeItem('user')
                    localStorage.removeItem('token')
                    localStorage.removeItem('timeout')
                    this.cookieService.delete('token')
                    jQuery('body').attr('class', 'blue')
                    localStorage.removeItem('urlLogo')
                    localStorage.removeItem('classThemeBody')
                    return this.router.navigateByUrl('/app/login')
                } else {
                    this.requestService.downloadFile(id, name)
                }
            }
        }
    }

    private onShowPdf(event) {
        const id = event.id
        this.requestService.setLoading(true)
        this.requestService
        .httpGetBaseApi(imageStatusUrl + '/' + id)
        .subscribe((success) => {
            cordova.InAppBrowser.open(success['url'], '_system', 'location=yes')
            this.requestService.setLoading(false)
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/commons/base-pdf/base-pdf.component.ts